module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/female-4-12f9d3ff6b21a7c61ddd4d842c7aa57f.jpg";